// update mobile

export function updateMobileMap(ref, { stationId, categoryId }) {
  resetMobileMap(ref);

  if (stationId) {
    mapStationMobileChange(ref, stationId);
  } else if (categoryId) {
    mapCategoryMobileChange(ref, categoryId);
  }
}

const MAP_VIEWBOX = {
  x: 0,
  y: 0,
  w: 390,
  h: 844,
  wHalf: 195,
  hHalf: 422,
  wSmallest: 390 / 1.2,
  hSmallest: 844 / 1.2,
};

function resetMobileMap(ref) {
  resetViewBox(ref);

  // reset map svg class
  ref.classList.remove(...ref.classList);
  ref.classList.add(
    ...'maps-outline-mobile h-screen w-full absolute top-0 left-0'.split(' ')
  );
  // show all areas & pin category
  ref
    .querySelectorAll('#categoryPins')
    .forEach((area) => area.classList.remove('hidden'));
}

function mapCategoryMobileChange(ref, categoryId) {
  if (!categoryId) return;

  // hide all category pins
  ref.querySelector(`#categoryPins`).classList.add('hidden');

  // reset svg size
  resetViewBox(ref);
  // scale svg
  let viewBox = ref.viewBox.baseVal;
  viewBox.width = MAP_VIEWBOX.wHalf;
  viewBox.height = MAP_VIEWBOX.hHalf;

  // move the map according area
  if (categoryId === 'grazing') {
    viewBox.x = 120;
    viewBox.y = 290;
  } else if (categoryId === 'breeding') {
    viewBox.x = 0;
    viewBox.y = 80;
    viewBox.width = MAP_VIEWBOX.wSmallest;
    viewBox.height = MAP_VIEWBOX.hSmallest;
  } else if (categoryId === 'nourishing') {
    viewBox.x = 190;
    viewBox.y = 260;
  } else if (categoryId === 'progressing') {
    viewBox.x = 195;
    viewBox.y = 300;
  }
}

function mapStationMobileChange(ref, stationId) {
  if (!stationId) return;

  // hide all category pin and area
  ref
    .querySelectorAll('#categoryPins')
    .forEach((area) => area.classList.add('hidden'));

  resetViewBox(ref);
  let viewBox = ref.viewBox.baseVal;
  viewBox.width = MAP_VIEWBOX.wHalf;
  viewBox.height = MAP_VIEWBOX.hHalf;
  // move the map according station
  if (['anthony-lagoon', 'eva-downs', 'brunette-downs'].includes(stationId)) {
    viewBox.x = 0;
    viewBox.y = 130;
  } else if (['avon-downs', 'austral-downs', 'headingly'].includes(stationId)) {
    viewBox.x = 0;
    viewBox.y = 170;
  } else if (
    ['wondoola', 'canobie', 'dalgonally', 'carrum'].includes(stationId)
  ) {
    viewBox.x = 40;
    viewBox.y = 140;
  } else if (['south-galway'].includes(stationId)) {
    viewBox.x = 100;
    viewBox.y = 260;
  } else if (['glentana', 'wylarah'].includes(stationId)) {
    viewBox.x = 100;
    viewBox.y = 260;
  } else if (['goonoo-feedlot', 'aronui-feedlot'].includes(stationId)) {
    viewBox.x = 170;
    viewBox.y = 230;
  } else if (['processing-plant'].includes(stationId)) {
    viewBox.x = 170;
    viewBox.y = 290;
  }
}

function resetViewBox(ref) {
  // reset map svg viewbox
  let viewBox = ref.viewBox.baseVal;
  viewBox.x = MAP_VIEWBOX.x;
  viewBox.y = MAP_VIEWBOX.y;
  viewBox.width = MAP_VIEWBOX.w;
  viewBox.height = MAP_VIEWBOX.h;
}
